module.exports = __webpack_public_path__ + "img/Metastasis-OVCA_10X_TPCP.4932dc7c.png";